<template>
  <td :class="[`cell-value-${col}`]">
    {{ entry[col] }}
  </td>
</template>

<script>
export default {
  props: {
    entry: Object,
    col: String,
  },
};
</script>
